import createHistory from "history/createBrowserHistory";
import * as app from "./state/actions/app.actions";

const history = createHistory();

const pushHistory = location => history.push(location);

const configureHistory = store => {
  history.listen(() => {
    store.dispatch(app.routeChanged());
    window.scrollTo(0, 0);
  });

  return history;
};

export { configureHistory, pushHistory };
